import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Responsible Person Assignment: The association(s) between personnel and space as responsible persons.',
    name: 'Responsible Person Assignments',
    partialId: PartialId.Standard.create('resp_person'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
